var exports = {
  "vK": "GiftInventoryBanner.module__banner___Zmk1RE",
  "Qs": "GiftInventoryBanner.module__content___Zmk1RE",
  "Kk": "GiftInventoryBanner.module__icon___Zmk1RE",
  "FS": "GiftInventoryBanner.module__textContainer___Zmk1RE",
  "DD": "GiftInventoryBanner.module__title___Zmk1RE",
};

module.exports = exports;
